import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

import { MicroApplication } from "../_models/microapplication.model";
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';



import { resolve } from "@angular/compiler-cli/src/ngtsc/file_system";
import { MessagesService } from "../../service.index";
import { ConfigService } from "../../config.service";
import { ActionResult, ActionResultF } from "src/app/models/auth/_models/action-result";
import { datawidget } from "src/app/models/auth/_models/user.model";
@Injectable({
  providedIn: "root",
})
export class MicroapplicationService {
  microappsData: BehaviorSubject<MicroApplication[]> = new BehaviorSubject<MicroApplication[]>(null);
  widgetdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  loadingObserver: Observable<boolean>;
  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading = false;
  loadingForm = false;

  formChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  constructor(private http: HttpClient, private _messagesService: MessagesService, private configService: ConfigService) {

    this.loadingObserver = this.loadingSubject.asObservable();

  }

  changeForm() {
    this.formChanged.next(true);
  }

  GetAllMicroApplications() {

    this.loading = true;
    return this.http
      .get<ActionResult<MicroApplication[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/Get`)
      .subscribe((result) => {
        this.loading = false;
        if (result.isSuccessful) {
          this.microappsData.next(result.result);
        }
      }, err => this.loading = false);
  }

  GetAllwidget(codEmpresa: string) {

    this.loading = true;
    return this.http
      .get<ActionResult<any[]>>(`${this.configService.config.apiMicroApplicationsSeven}/WidgetsGetall?companyCode=${codEmpresa}`)
      .subscribe((result) => {
        this.loading = false;
        if (result.isSuccessful) {
          this.widgetdata.next(result.result);
        }
      }, err => this.loading = false);
  }

  // GetMainFrom(usu_coi :string,code:string) {
  //   this.loading = true;
  //   return this.http
  //     .get<ActionResult<any[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetMainFrom?companyCode=${usu_coi}&companyCode=${code}`)
  //     .subscribe((result) => {
  //       this.loading = false;
  //       if (result.isSuccessful) {
  //         this.widgetdata.next(result.result);
  //       }
  //     },err=>this.loading=false);
  // }

  GetMainFrom(usu_coi: string, code: string) {
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetMainFrom?usu_codi=${usu_coi}&code=${code}`);
  }

  public GetAllMicroApplicationsTabs() {
    return this.http.get<ActionResult<any[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetMicroApplicationstab`)
  }

  GetMicroApplicationsById(id: any) {
    this.loading = true;
    return this.http
      .get<ActionResult<MicroApplication>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/${id}`);
  }

  GetwidgetById(companyCode: any, wid_cont: string) {
    this.loading = true;
    return this.http
      .get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetwidgetById?companyCode=${companyCode}&wid_cont=${wid_cont}`);
  }

  GetWidget(companyCode: number, year: number) {
    return this.http
      .get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/Widgets?companyCode=${companyCode}&year=${year}`).pipe(map(resp => {
        if (!resp.isSuccessful) {
          this._messagesService.error(resp.errorMessage);
        }
        return { series: [{ name: 'Facturas', data: resp.result.values }] };
      }))
  }


  GetWidgets() {
    return this.http
      .get<ActionResult<any[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetWidgets`);
  }
  GetMicroApplicationsByCodForm(codeForm: any) {
    this.loading = true;
    return this.http
      .get<ActionResult<MicroApplication>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetByFormCode?codeForm=${codeForm}`);
  }


  postMicroApplication(subject: MicroApplication) {
    this.loadingSubject.next(true);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/new`, subject).pipe(map(resp => {
      this.loadingSubject.next(false);
      if (!resp.isSuccessful) {
        this._messagesService.error(`Error modificando microaplicación: ${resp.errorMessage}`);
      }
      return resp;
    }))
  }

  GetwidgetByIdsave(emp_codi: string, gn_usuar: string, datasave: datawidget[]) {
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetwidgetById/new`, { emp_codi: emp_codi, gn_usuar: gn_usuar, datasave: datasave })
  }
  GetwidgetByIdupdate(emp_codi: string, gn_usuar: string, datasave: datawidget[]) {
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetwidgetById/Update`, { emp_codi: emp_codi, gn_usuar: gn_usuar, datasave: datasave })
  }
  GetUserList(widcont: string) {
    return this.http
      .get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetUserList?widcont=${widcont}`);
  }
  GetUserListadd() {
    return this.http
      .get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetUserListadd`);
  }

  public GetwidgetByIddelete(emp_codi: string, gn_usuar: string, datasave: datawidget[]) {
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetwidgetById/Delete`, { emp_codi: emp_codi, gn_usuar: gn_usuar, datasave: datasave })
  }

  postWidget(subject: any) {
    this.loadingSubject.next(true);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/new`, subject).pipe(map(resp => {
      this.loadingSubject.next(false);
      if (!resp.isSuccessful) {
        this._messagesService.error(`Error modificando microaplicación: ${resp.errorMessage}`);
      }
      return resp;
    }))
  }

  updateMicroApplication(subject: MicroApplication) {
    this.loadingSubject.next(true);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/UpdateMicroApp`, subject).pipe(map(resp => {
      this.loadingSubject.next(false);
      if (!resp.isSuccessful) {
        this._messagesService.error(`Error modificando microaplicación: ${resp.errorMessage}`);
      }
      return resp;
    }))

  }

  WidgetsList(companyCode: any, usu_codi: string) {
    this.loading = true;
    return this.http
      .get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/WidgetsList?companyCode=${companyCode}&usu_codi=${usu_codi}`);
  }

  public  GetTaskSummary(usu_codi:string, emp_codi: string){   
		return this.http.get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetTaskSummary?usu_codi=${usu_codi}&emp_codi=${emp_codi}`);
	  }

    public  GetWorkFlow(usu_codi:string, emp_codi: string){   
      return this.http.get<ActionResult<any>>(`${this.configService.config.apiMicroApplicationsSeven}/GetWorkFlow?usu_codi=${usu_codi}&emp_codi=${emp_codi}`);
      }

  importJSONFile(jsonFile: any) {
    this.loading = true;
    this.loadingSubject.next(true);
    return this.http.post<ActionResultF<any>>(`${this.configService.config.apiProcessTable}mainForm/setMetadataForm`, jsonFile).pipe(map(resp => {       
       if (!resp.IsSucessfull){        
        this._messagesService.error(`Error importando metadata: ${resp.ErrorMessage}`);
        this.loadingSubject.next(false);
       }         
       else{
        this._messagesService.success(resp.Result);
        this.loadingSubject.next(false);
       }        
       return resp;
     }))
  }

  ValidarLicencia(usu_coi: string, code: string) {
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/ValidarLicencia?usu_codi=${usu_coi}&emp_codi=${code}`);
  }

}
